import { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Modal, Divider, useToaster, Message } from "rsuite";
import { configCRUD } from "../../../actions/config";
import { selector } from "../../../api";
import { char } from "../../../utils";
import { Input, Select } from "antd";

const dictionaryItemSchema = Yup.object().shape({
  dictionary_item_name: Yup.string().required("This field is required"),
  dictionary: Yup.string().required("This field is required"),
});

const initialValues = {
  dictionary_item_code: "",
  dictionary_item_name: "",
  dictionary_item_parent: null,
  dictionary: "",
};

export const DictionaryItemAdd = (props) => {
  const { open, setOpen, index, setIndex } = props;
  const user = selector.User();
  const toaster = useToaster();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [dictionary, setDictionary] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      configCRUD
        .loadDictionary(15, 0, value)
        .then((resp) => {
          setDictionary(resp.data.results);
        })
        .finally(() => {});
    }, 500);
  }, [value]);

  const formik = useFormik({
    initialValues,
    validationSchema: dictionaryItemSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { dictionary_item_code, dictionary_item_name, dictionary } = values;
      const recorded_by = user.id;
      const data = {
        dictionary_item_code,
        dictionary_item_name,
        dictionary,
        recorded_by,
      };
      setLoading(true);
      setTimeout(() => {
        configCRUD
          .addDictionaryItem([data])
          .then(() => {
            toaster.push(
              <Message type="success" showIcon header={"Success"} closable>
                <p className="h6">
                  <p className="fw-bold fs-14">Thank you...!</p>
                  <p className="text-dark fs-12">
                    Dictionary Item has been added successfully.
                  </p>
                </p>
              </Message>,
              { placement: "topEnd", duration: 7000 }
            );
            setIndex(index + 1);
            resetForm();
            setLoading(false);
            setSubmitting(false);
            setOpen(false);
          })
          .catch((error) => {
            setLoading(false);
            setSubmitting(false);
            toaster.push(
              <Message type="error" showIcon header={"Error"} closable>
                <p className="h6">
                  <p className="fw-bold fs-14">Oooh Sorry...!</p>
                  <p className="text-dark fs-12">{error}.</p>
                </p>
              </Message>,
              { placement: "topEnd", duration: 7000 }
            );
          });
      }, 2000);
    },
  });

  const handleClose = () => {
    setOpen(false);
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <>
      <Modal open={open} onClose={handleClose} size="md">
        <Modal.Header>
          <Modal.Title>New Dictionary Item</Modal.Title>
        </Modal.Header>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-sm-12">
                  <div className="form-group">
                    <label className="text-body mb-2">Dictionary Code</label>
                    <Input
                      className="form-control"
                      placeholder="Dictionary code"
                      {...formik.getFieldProps("dictionary_item_code")}
                    />
                  </div>
                </div>
                <div className="col-md-4 col-sm-12">
                  <div className="form-group">
                    <label className="text-body mb-2">
                      Dictionary <span className="text-danger fw-bold">*</span>
                    </label>
                    <Select
                      size="large"
                      className="w-100"
                      showSearch
                      placeholder="Select dictionary"
                      optionFilterProp="children"
                      onChange={(e) => formik.setFieldValue("dictionary", e)}
                      onSearch={(e) => setValue(e)}
                      filterOption={filterOption}
                      options={dictionary?.map((dt) => ({
                        value: dt.id,
                        label: char.toUpperCaseFirst(dt.dictionary_name),
                      }))}
                      status={
                        formik.touched.dictionary &&
                        formik.errors.dictionary &&
                        "error"
                      }
                    />
                    {formik.touched.dictionary && formik.errors.dictionary && (
                      <div
                        className="fw-light mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        <span role="alert" className="text-danger">
                          {formik.errors.dictionary}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-4 col-sm-12">
                  <div className="form-group">
                    <label className="text-body mb-2">
                      Dictionary Item Name{" "}
                      <span className="text-danger">&nbsp;*</span>
                    </label>
                    <Input
                      className="form-control"
                      placeholder="Dictionary item name"
                      {...formik.getFieldProps("dictionary_item_name")}
                      status={
                        formik.touched.dictionary_item_name &&
                        formik.errors.dictionary_item_name &&
                        "error"
                      }
                    />
                    {formik.touched.dictionary_item_name &&
                      formik.errors.dictionary_item_name && (
                        <div
                          className="fw-light mt-1"
                          style={{ fontSize: "12px" }}
                        >
                          <span role="alert" className="text-danger">
                            {formik.errors.dictionary_item_name}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Divider style={{ marginTop: -10 }} />
          <Modal.Footer>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 d-flex justify-content-start">
                  <span className="fs-18 text-danger"> * &nbsp;</span> Reuired
                  field
                </div>
                <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                  <button
                    onClick={handleClose}
                    className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                  >
                    <i class="ri-forbid-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-soft-success btn-label waves-effect waves-light rounded-pill"
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    {!loading && (
                      <span className="indicator-label">
                        <i class="ri-check-double-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                        Save
                      </span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
